import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';
import Steps from './../basics/Steps';
import ShopHeader from './../shop/ShopHeader';
import {useLocation} from 'react-router-dom';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const ReservationConfirm = () => {

  const services = new Services();

  const location:any = useLocation();

  let reservationId: any = ''

  const [reservationName, setReservationName] = useState<any>(null);

  console.log(location);

  useEffect(()=>{

    services.createReservation(JSON.parse(String(localStorage.getItem('bk_reservant'))), location.state.term).then((value: any) => {
      console.log('Hlavička rezervace vytvořena: ' + value.id)
      console.log('Reservation id before')
      console.log(value.id);
      console.log(value.firstname);

      reservationId = value.id
      setReservationName( value.firstname + ' ' + value.lastname )

      let reservations: Array<object> = JSON.parse(String(localStorage.getItem('bk_reservations')));

      console.log(reservations)
      console.log('Reservation id')
      console.log(reservationId)

      reservations.forEach((reservation: any) => {

        services.addReservation( reservation.ticket, location.state.term, reservationId).then((value: any) => {
          console.log('Letenka přidána')
        })

      })

      localStorage.removeItem('bk_reservant')
      localStorage.removeItem('bk_reservations')

    })

  }, [])

  const steps = [

    {'name':'Obchod', 'link':'/term-list', 'active': true},
    {'name':'Košík','link': '/passenger-list/'+location.state.term, 'active': true},
    {'name':'Pokladna','link': '/reservation-confirm', 'active': false},

  ];

  return (

    <div>

      <ShopHeader title="Potvrzení rezervace" image="http://balony.techcrowd.cz/reservation.jpg"/>

      <div className="container my-5 py-5">

        <Steps links={steps} />

        <div className="d-flex flex-column align-items-center my-5 py-5">
            <i className="text-success fa-2xl fa-solid fa-circle-check"></i>
            <div className="fs-2">{reservationName}</div>
            <div>Vaše rezervace je potvrzena</div>
            <div className="card border-0 custom-radius custom-shadow col-9 mx-auto mt-5">
              <div className="card-body p-5">
                {location.state.reservations.map((element:any, index:number) => (
                  <div>
                    <div className="d-none d-lg-block">
                      <div className="row my-3 py-4 w-100">
                        <div className="col-4 border-end py-4"><strong>Letenka: </strong>{element.ticket}</div>
                        <div className="col-4 border-end py-4"><strong>Jméno a příjemní: </strong>{element.name} {element.surname}</div>
                        <div className="col-4 py-4"><strong>Hmotnost: </strong>{element.weight} kg</div>
                      </div>
                    </div>
                    <div className="d-block d-lg-none">
                      <div className="row my-3 py-4 w-100 border-bottom">
                        <div className="col-12 py-4"><strong>Letenka: </strong>{element.ticket}</div>
                        <div className="col-12 py-4"><strong>Jméno a příjemní: </strong>{element.name} {element.surname}</div>
                        <div className="col-12 py-4"><strong>Hmotnost: </strong>{element.weight} kg</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default ReservationConfirm;
